import dayjs, { Dayjs, ManipulateType } from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(objectSupport);
dayjs.extend(relativeTime);
dayjs.extend(dayOfYear);
dayjs.extend(duration);

dayjs.updateLocale('es', {
  // By default a dot is added. Ex: lun., mar.
  weekdaysShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
});

export const isBetweenInclusive = (date: Dayjs, start: Dayjs, end: Dayjs) => {
  return date.isBetween(start, end, null, '[]');
};

export function formatElapsedSeconds(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds));

  const parts = [
    [Math.floor(total / 86_400), 'd'],
    [Math.floor(total / 3_600) % 24, 'h'],
    [Math.floor(total / 60) % 60, 'm'],
    [total % 60, 's'],
  ] as const;

  return (
    parts
      .filter(([value]) => value > 0)
      .map(([value, unit]) => `${value}${unit}`)
      .join(' ') || '0s'
  );
}

export function formatElapsedSince(since: Date, now: Date = new Date()): string {
  const seconds = Math.floor((now.getTime() - since.getTime()) / 1000);
  return formatElapsedSeconds(seconds);
}

export { dayjs };
export type { Dayjs, ManipulateType };
